export default "__VITE_ASSET__D$rBoj_o__"